import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { URLS } from '../../../shared/constants/urls.constant';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { BankTransferInfoDialogBuilder } from './bank-transfer-info-dialog.builder';
import { AchDebit } from '../../../settings-data/sub-models/company-settings/ach-debit.model';

export const DIALOG_TYPE = 'bank-transfer-info';

@Component({
  selector: 'app-bank-transfer-info-dialog',
  templateUrl: './bank-transfer-info-dialog.component.html',
  styleUrls: ['./bank-transfer-info-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [BankTransferInfoDialogBuilder],
})
export class BankTransferInfoDialogComponent implements OnInit, OnChanges {
  @Input() achDebit: AchDebit;
  @Input() locale: string;

  @Output() onConfirm: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

  dialogType: string;
  description: string;
  confirmUrl: string;
  listItems: List<string>;
  trackingObject: ITrackingObject;
  trackingScreenName: TrackingScreenNamesEnum;

  constructor(
    private _translateService: TranslateService,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _bankTransferInfoDialogBuilder: BankTransferInfoDialogBuilder
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.achDebit && changes.locale && this.achDebit) {
      this.description = this._bankTransferInfoDialogBuilder.buildDescription(
        this.achDebit,
        this.locale
      );
    }
  }

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.confirmUrl = URLS.PAYMENTS_BANK_TRANSFER;
    this.listItems = this._bankTransferInfoDialogBuilder.buildListItems();
  }
}
